
const MoneyPage = (props) => {

    const setValue = () => {
        let userInput = document.getElementById('dollar-input')
        props.userInputValue(userInput.value)
        console.log(userInput.value)
    }
    
    return(
        <div className="h-100">
            <div className="row space-between">
                <div className="right-third">
                    <h1 className="title-text mb-1">Decide to offset based on your company’s budget.</h1>
                    <div className="row flex-start">
                        <div className="input-rect mr-1">
                            <p id="dollar-sign">$</p>
                            <input 
                                type="number"
                                id='dollar-input'
                                className="number-input"
                                ></input>
                            
                        </div>
                        <div>
                            <button className="pointer" onClick={()=> {
                                props.setPage('almostThere')
                                setValue()
                                }}>Submit</button>
                            <p className="f-12 f-yellow pointer" onClick={()=> props.setPage('home')}>Or choose another way</p>
                        </div>
                    </div>
                </div>
                <div className="sign-conntainer">
                    <div className="sign-top"></div>
                    <div className="sign">
                        <div className="col space-around">
                            <h3 className="f-16 m-0">Tip:</h3>
                            <p className="f-16 m-0">$14.80 will offset 1 metric ton of carbon in Mississippi.</p>
                            <br></br>
                        </div>
                    </div>
                </div>
            </div>
            <div className="align-end mt-5">

                <p className="f-14 f-gray">Change your mind? Choose a different way to get involved.</p>
                <div className="row space-between">
                    <div className="f-12 pointer f-c" onClick={() => props.setPage('tons')}>
                        METRIC TONS
                    </div>
                    <div className="footer-line"></div>
                    <div className="f-yellow f-12 f-c">
                        DOLLARS INVESTED
                    </div>
                    <div className="footer-line"></div>
                    <div className="f-12 pointer f-c" onClick={() => props.setPage('watts')}>
                        NEW SOLAR WATTS
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MoneyPage;